import { render, staticRenderFns } from "./GroupRegisterView.vue?vue&type=template&id=2df62bd2&scoped=true&"
import script from "./GroupRegisterView.vue?vue&type=script&lang=js&"
export * from "./GroupRegisterView.vue?vue&type=script&lang=js&"
import style0 from "./GroupRegisterView.vue?vue&type=style&index=0&id=2df62bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df62bd2",
  null
  
)

export default component.exports